import { muiStyles } from 'utils/design';

export const useStyles = muiStyles<{ floatingMenus: boolean }>((_theme, { floatingMenus }) => ({
  icon: {
    fontSize: '1.2rem',
  },
  iconWrapper: {
    minWidth: floatingMenus ? 40 : 56,
  },
  expandIcon: {
    marginLeft: 'auto',
  },
  listItemText: {
    flex: '1 1 auto',
    minWidth: 0,
  },
}));
